exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-overflow[data-v-35cc27ca]{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}", ""]);

// exports
